<div class="create-dataconnectiion-wrapper">
  <h2 class="nfl-form-label mb1" nz-typography>{{ this.appService.dataConnectionHeader }}</h2>
  <nz-layout>
    <nz-content class="content">
      <app-data-connection-stepper
        [stepper]="stepper"
        [selectedDatasource]="selectedDatasource"
      ></app-data-connection-stepper>

      <app-datasource-selection *ngIf="stepper === 0" (datasourceSelect)="onDatasourceSelect($event)">
      </app-datasource-selection>

      <app-data-connection-details
        [selectedDatasource]="selectedDatasource"
        *ngIf="stepper === 1"
        (backEvent)="onBack()"
      ></app-data-connection-details>

      <app-data-connection-mappings *ngIf="stepper === 3"></app-data-connection-mappings>
    </nz-content>
  </nz-layout>
</div>
